import store from '@/store';

const getIntlString = function (object, intlCollection, defaultValue) {
  return object[intlCollection] && object[intlCollection][store.state.auth.contact.localeShort]
    ? object[intlCollection][store.state.auth.contact.localeShort]
    : defaultValue;
};

const getIntlName = function (object) {
  return object.intlNames && object.intlNames[store.state.auth.contact.localeShort]
    ? object.intlNames[store.state.auth.contact.localeShort]
    : object.defaultName;
};

const getIntlComment = function (object) {
  return object.intlComments && object.intlComments[store.state.auth.contact.localeShort]
    ? object.intlComments[store.state.auth.contact.localeShort]
    : object.defaultComment;
};

export {getIntlName, getIntlComment, getIntlString};
